<!-- eslint-disable vue/html-indent -->
<template>
  <a-drawer placement="left" :closable="false" :visible="visible" :mask="false" :get-container="false"
    :wrap-style="{ position: 'absolute' }"
    style="background: rgba(0, 32, 54, 0.75); box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1)" :zIndex="980">
    <div slot="title" style="margin-bottom: 0px">
      <div class="radius"></div>
      <div class="radius-title">查询</div>
    </div>
    <a-form-model class="log-form" ref="addOrUpdateForm" :model="addOrUpdateForm" :rules="rules">
      <a-form-model-item style="margin-bottom: 0px" :labelCol="labelCol" :wrapperCol="wrapperCol" label="查询属性">
        // eslint-disable-next-line vue/max-attributes-per-line
        <a-select default-value="请选择" v-model="currentSelectLayerQueryType" @change="layerPropertiesQuery"
          style="color: #fff">
          <a-select-option value="pipe_diameter_size"> 管径 </a-select-option>
          <a-select-option value="pipeline_material"> 材质 </a-select-option>
          <a-select-option value="geophysical_point_number"> 分类编码 </a-select-option>
          <a-select-option value="user_point_number"> 用户编码 </a-select-option>
          <a-select-option value="user_point_name"> 用户名称 </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item style="margin-bottom: 0px" :labelCol="labelCol" :wrapperCol="wrapperCol" label="属性值">
        <a-select v-if="
          currentSelectLayerQueryType !== 'geophysical_point_number'
        " mode="multiple" v-model="layerPropertiesValues">
          <a-select-option v-for="(item, index) in propertiesTypeOptions" :key="index" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
        <a-input v-else v-model="layerPropertiesValue" />
      </a-form-model-item>
    </a-form-model>
    <div style="margin-top: 30px">
      <a-button style="margin-left: 30px" type="primary" @click="queryLayerProperties">查询</a-button>
      <a-button style="margin-left: 8px" @click="reset">重置</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getPipeDiameterSize, getPipeLineMaterial, getCqlExtent } from '@/api/manage'
// import { geoserverWFS } from '@/api/manage'
export default {
  name: 'BigMapDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedItems: [],
      propertiesTypeOptions: [],
      currentSelectLayerQueryType: '', // 当前选择查询的类型
      layerPropertiesValues: [], // 图层属性查询条件
      layerPropertiesValue: '', // 图层属性查询条件
      addOrUpdateForm: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 24 }
      }
    }
  },
  computed: {
    rules () {
      return {}
    }
  },
  methods: {
    reset () {
      this.currentSelectLayerQueryType = ''
      this.layerPropertiesValues = ''
      this.layerPropertiesValues = []
      this.$parent.removeLayerByName('condition_query_wms_layer')
    },
    handleChange (selectedItems) {
      this.selectedItems = selectedItems
    },
    queryLayerProperties () {
      if (this.currentSelectLayerQueryType && (this.layerPropertiesValues.length !== 0 || this.layerPropertiesValue)) {
        let cql = `(is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}') and`
        if (this.currentSelectLayerQueryType && this.layerPropertiesValues) {
          if (this.currentSelectLayerQueryType !== 'geophysical_point_number') {
            let tmpCql = ''
            this.layerPropertiesValues.forEach((item, index) => {
              if (index === 0) {
                tmpCql += this.currentSelectLayerQueryType + `= '${item}'`
              } else {
                tmpCql += ' or ' + this.currentSelectLayerQueryType + `= '${item}'`
              }
            })
            cql = cql + '(' + tmpCql + ')'
          } else {
            cql = cql + ` ${this.currentSelectLayerQueryType} = '${this.layerPropertiesValue}'`
          }
        }
        // alert(cql)
        // geoserverWFS('smart_water', 'pipe_network', cql).then(res =>{
        //   console.log('geoserverwfs', res)
        // })
        this.$parent.queryWmsLayers('smart_water', 'smart_water:pipe_network', cql)
        getCqlExtent(cql).then((res) => {
          // console.log(JSON.parse(res.data.geoJson).coordinates)
          const xy = JSON.parse(res.data.geoJson).coordinates
          if (xy.length > 0) {
            this.$parent.getBigMap().getView().setCenter(xy[0])
            this.$parent.getBigMap().getView().setZoom(16)
          }
        })
      } else {
        this.$message.error('请选择查询属性或者输入、选择属性值！')
      }
    },
    layerPropertiesQuery (propertiesType) {
      this.currentSelectLayerQueryType = propertiesType
      this.layerPropertiesValues = []
      this.layerPropertiesValue = ''
      this.propertiesTypeOptions = []
      if (propertiesType === 'pipe_diameter_size') {
        getPipeDiameterSize().then((res) => {
          res.data.forEach((items, index) => {
            this.propertiesTypeOptions.push(items)
          })
        })
      }
      if (propertiesType === 'pipeline_material') {
        getPipeLineMaterial().then((res) => {
          res.data.forEach((items, index) => {
            this.propertiesTypeOptions.push(items)
          })
        })
      }
    },
    show (arr) {
      this.$nextTick(() => { })
    },
    close () {
      //   this.disableSubmit = false
      this.selectedRowKeys = []
    },

    handleOk () {
      const that = this
      console.log(that.selectedRows)
      const arr = this.selectedRows
      this.$emit('close', arr)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-drawer-content-wrapper {
  background: rgb(0, 32, 54);
  opacity: 0.75;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

/deep/ .ant-drawer-wrapper-body {
  background: rgba(0, 32, 54, 0.75);
  /*opacity: 0.75;*/
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

/deep/ .ant-drawer-header {
  background: rgba(8, 144, 242, 0.18);
  border-bottom: 0px solid #e8e8e8;
}

/deep/ .ant-form-item-label>label {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.56px;
  font-weight: 400;
}

/deep/ .ant-select-selection {
  border: 1px solid #939393;
  border-radius: 4px;
  background: rgba(0, 32, 54, 0);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

.radius {
  float: left;
  width: 4px;
  height: 16px;
  background: #ffffff;
  border-radius: 0px;
}

.radius-title {
  margin-left: 15px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
}

.log-form {
  padding: 0;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #404549;
  letter-spacing: 0.56px;
  font-weight: 400;
}

.ant-drawer-body {
  padding: 0;
}
</style>
